import { useState, useMemo } from "react";
import useSettings from "../../hooks/Settings";
import PersonaAnalysis from "../../components/analysis/PersonaAnalysis";
import PortfolioProjectAnalysis from "../../components/analysis/PortfolioProjectAnalysis";
import SelectableGrid from "../../components/common/SelectableGrid";

// Deprecated page — the per-entity analyses moved to the deep-analysis pages
// (/deepanalysis/:type/:id). Only the not-yet-migrated analyses live here:
// participants (persona) and portfolio.

/**
 * Legacy "Diepe analyse" page. Hosts the deferred analyses that don't yet have
 * a deep-analysis anchor: participant (persona) and portfolio. Migrated
 * analyses (activities, outputs, research) now live on the deep-analysis pages.
 */
const AddAnalysis = () => {
  const { portfolio, personasOn } = useSettings();

  const tabs = useMemo(() => {
    const items = []
    if (personasOn === 'flex') items.push({ id: 'clients', label: 'Deelnemers' })
    if (portfolio === 'block') items.push({ id: 'portfolio', label: 'Portfolio' })
    return items
  }, [personasOn, portfolio])

  const [navigation, setNavigation] = useState(tabs[0] ? tabs[0].id : '');

  const renderAnalysis = () => {
    switch (navigation) {
      case "clients":
        return <PersonaAnalysis />;
      case "portfolio":
        return <PortfolioProjectAnalysis />;
      default:
        return null;
    }
  };

  return (
    <div className="main">
      <div className="main-container">
        <div className="page-header">
          <h1>Diepe analyse uitvoeren</h1>
        </div>
        <SelectableGrid
          items={tabs}
          getId={(item) => item.id}
          getLabel={(item) => item.label}
          selectedId={navigation}
          onClick={setNavigation}
        />

        {renderAnalysis()}
      </div>
    </div>
  );
};

export default AddAnalysis;
